export default __webpack_public_path__ + "static/media/fondoDetallesKalenday.2812915e.png";